module.exports = __webpack_public_path__ + "static/media/Dashboard.769570b3.png";